import { supabase } from './client';

export async function getTeams() {
  const { data, error } = await supabase
    .from('teams')
    .select(`
      id,
      name,
      short_name,
      color,
      logo_url,
      players (
        id,
        name,
        number,
        team_id
      )
    `)
    .order('name');

  if (error) throw error;
  return data;
}

// --- Team CRUD ---

export async function createTeam(data: { name: string; shortName: string; color: string; logoUrl?: string | null }) {
  const { data: result, error } = await supabase
    .from('teams')
    .insert({ name: data.name, short_name: data.shortName, color: data.color, logo_url: data.logoUrl || null })
    .select()
    .single();
  if (error) throw error;
  return result;
}

export async function updateTeam(id: string, data: { name?: string; shortName?: string; color?: string; logoUrl?: string | null }) {
  const update: Record<string, string | null> = {};
  if (data.name !== undefined) update.name = data.name;
  if (data.shortName !== undefined) update.short_name = data.shortName;
  if (data.color !== undefined) update.color = data.color;
  if (data.logoUrl !== undefined) update.logo_url = data.logoUrl || null;

  const { data: result, error } = await supabase
    .from('teams')
    .update(update)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return result;
}

export async function deleteTeam(id: string) {
  const { error } = await supabase.from('teams').delete().eq('id', id);
  if (error) throw error;
}

// --- Player CRUD ---

export async function createPlayer(data: { teamId: string; name: string; number: number }) {
  const { data: result, error } = await supabase
    .from('players')
    .insert({ team_id: data.teamId, name: data.name, number: data.number })
    .select()
    .single();
  if (error) throw error;
  return result;
}

export async function updatePlayer(id: string, data: { name?: string; number?: number }) {
  const update: Record<string, string | number> = {};
  if (data.name !== undefined) update.name = data.name;
  if (data.number !== undefined) update.number = data.number;

  const { data: result, error } = await supabase
    .from('players')
    .update(update)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return result;
}

export async function deletePlayer(id: string) {
  const { error } = await supabase.from('players').delete().eq('id', id);
  if (error) throw error;
}
